const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	listaSelect: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'DEPARTAMENTO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'DEPARTAMENTO_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

        case 'DEPARTAMENTO_LISTADO':
            return {
				...state,
				lista: action.payload.data.filter(item => {
					if (action.id_perfil == 1) {
						return true;
					} else if (!action.departamentos_usuario || !action.departamentos_usuario.length) {
						return false;
					} else {
						return action.departamentos_usuario.includes(item.id);
					}
				}),
				listaSelect: action.payload.data.map(item => ({ id: item.id, valor: item.nome })).filter(item => {
					if (action.id_perfil == 13) {
						return true;
					} else if (!action.departamentos_usuario || !action.departamentos_usuario.length) {
						return false;
					} else {
						return action.departamentos_usuario.includes(item.id);
					}
				})
			};
			
        default:
            return state;
    }
}
